import { useQueryDefaultPODisclaimer } from '@webapp/modules/purchasing/features/get-default-po-disclaimer/models'

/**
 * Reads the `default-disclaimer` system preference for the disclaimer list's
 * star state. A 404 (no preference) AND a stored `0` (cleared default) both
 * map to `null` (BHV-017b, BHV-018).
 */
export const useGetDefaultPODisclaimerPresenter = () => {
  const { value, isLoading } = useQueryDefaultPODisclaimer()

  return {
    defaultId: value === null || value === 0 ? null : value,
    isLoading,
  }
}
